/**
 * Canonical skeleton placeholder primitive.
 *
 * Wraps the legacy `.skel`, `.skel.w40`, `.skel.w70` utility classes
 * from crm/index.html. Used inside table rows during first-paint
 * loading; matches the row shape so the transition from skeleton to
 * data is layout-stable.
 *
 * Three widths only — they correspond to the three legacy class
 * variants. Custom widths would require either editing legacy CSS or
 * having Skeleton own its own width styling; both deferred until a
 * second non-standard-width consumer surfaces.
 *
 * No `height` prop yet — BookMeSettings's custom 16px height is the
 * sole non-default-height consumer today; it stays on the legacy
 * class with an inline override until a second consumer justifies
 * the prop.
 */

type SkeletonWidth = '40' | '60' | '70'

interface SkeletonProps {
  width?: SkeletonWidth
}

export function Skeleton({ width = '60' }: SkeletonProps) {
  // Default width (60%) is the bare `.skel` class — no width modifier.
  const className = width === '60' ? 'skel' : `skel w${width}`
  return <span className={className} />
}
